import { EventEmitter, Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {ModalConfirmationMessageComponent} from '../utils/modals/modal-confirmation-message/modal-confirmation-message.component';

@Injectable({
  providedIn: 'root'
})
export class ModalConfirmationService {

  constructor(private modalService : BsModalService) { }

  showMesssageConfirmationModal(title:string, body : string, buttonConfirmTxt : string, buttonCancelTxt : string, callbackConfirm : Function, callbackCancel? : Function){
    const bsModalRef : BsModalRef = this.modalService.show(ModalConfirmationMessageComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
    bsModalRef.content.title = title;
    bsModalRef.content.body = body;
    bsModalRef.content.buttonConfirmText = buttonConfirmTxt;
    bsModalRef.content.buttonCancelText = buttonCancelTxt;
    bsModalRef.content.callbackConfirmFunction = callbackConfirm;
    bsModalRef.content.callbackCancelFunction = callbackCancel;
  }

  showMesssageConfirmationModalPromise(
    title: string,
    body: string,
    buttonConfirmTxt: string,
    buttonCancelTxt: string,
    callbackConfirm: Function,
    callbackCancel?: Function
  ): Promise<void> {
    return new Promise((resolve) => {
      const bsModalRef: BsModalRef = this.modalService.show(ModalConfirmationMessageComponent, {
        backdrop: 'static', // Prevent closing on backdrop click
      });
      bsModalRef.content.title = title;
      bsModalRef.content.body = body;
      bsModalRef.content.buttonConfirmText = buttonConfirmTxt;
      bsModalRef.content.buttonCancelText = buttonCancelTxt;

      // Set up the callback functions to resolve the promise after execution
      bsModalRef.content.callbackConfirmFunction = async () => {
        const result = callbackConfirm();

        // Check if result is a Promise
        if (result instanceof Promise) {
          await result; // Wait for the async function to complete
        }

        resolve();
      };


      bsModalRef.content.callbackCancelFunction = () => {
        if (callbackCancel) callbackCancel();
        resolve();
      };
    });
  }
}
